import {
  createContext,
  type ComponentChildren,
  type FunctionComponent,
} from "preact";
import { useContext, useEffect, useState } from "preact/hooks";

import type { VideoAdSession } from "../application/VideoAdSession";
import type { VideoAdState } from "../application/video-ad-state";

interface VideoAdContextValue {
  session: VideoAdSession;
  state: VideoAdState;
}

const VideoAdContext = createContext<VideoAdContextValue | undefined>(undefined);
const ContextProvider = VideoAdContext.Provider as unknown as FunctionComponent<{
  value: VideoAdContextValue;
  children?: ComponentChildren;
}>;

export function VideoAdProvider({
  children,
  session,
}: {
  children: ComponentChildren;
  session: VideoAdSession;
}) {
  const [state, setState] = useState(session.getState());

  useEffect(() => session.subscribe(setState), [session]);
  useEffect(() => {
    void session.initialize();
  }, [session]);

  return (
    <ContextProvider value={{ session, state }}>
      {children}
    </ContextProvider>
  );
}

export function useVideoAd(): VideoAdContextValue {
  const value = useContext(VideoAdContext);
  if (!value) throw new Error("useVideoAd must be used inside VideoAdProvider");
  return value;
}
